import { render, staticRenderFns } from "./KeyboardHand.vue?vue&type=template&id=cd80438a&scoped=true&"
import script from "./KeyboardHand.vue?vue&type=script&lang=js&"
export * from "./KeyboardHand.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardHand.vue?vue&type=style&index=0&id=cd80438a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd80438a",
  null
  
)

export default component.exports